import { combineReducers } from 'redux'
import utilsReducer from "./utils";

export default combineReducers({
  utils: utilsReducer,
});